import React, { useEffect, useState } from "react";
import styles from "./ArrowForge.module.css";

const ArrowForge = () => {

    useEffect(() => {
        document.title = "Setas para Copiar (↔ ↑ ↓ →) | Biblioteca Completa de Símbolos - Fohattech";
    }, []);

    const [copied, setCopied] = useState(null);

    const copySymbol = (symbol) => {
        navigator.clipboard.writeText(symbol);
        setCopied(symbol);

        setTimeout(() => {
            setCopied(null);
        }, 1500);
    };

    const arrowGroups = [
        {
            title: "Setas Básicas",
            arrows: ["←", "↑", "→", "↓", "↔", "↕", "↚", "↛"]
        },
        {
            title: "Setas Duplas",
            arrows: ["⇐", "⇒", "⇑", "⇓", "⇔", "⇕", "⇍", "⇏"]
        },
        {
            title: "Setas Diagonais",
            arrows: ["↖", "↗", "↘", "↙", "⤡", "⤢"]
        },
        {
            title: "Setas Curvas",
            arrows: ["↩", "↪", "↺", "↻", "⟲", "⟳"]
        },
        {
            title: "Setas Longas",
            arrows: ["⟵", "⟶", "⟷", "⟸", "⟹", "⟺", "⟻", "⟼"]
        },
        {
            title: "Setas com Estilo",
            arrows: ["➜", "➝", "➞", "➤", "➢", "➣", "➥", "➦", "➧", "➨"]
        },
        {
            title: "Setas Técnicas",
            arrows: ["⤴", "⤵", "⤶", "⤷", "⤸", "⤹", "⤺", "⤻", "⤼", "⤽"]
        },
        {
            title: "Setas de Navegação",
            arrows: ["⏪", "⏩", "⏫", "⏬", "🔼", "🔽", "◀", "▶"]
        },
        {
            title: "Setas com Cauda",
            arrows: ["➳", "➵", "➸", "➺", "➻", "➼", "➽", "➾"]
        },
        {
            title: "Setas Grossas",
            arrows: ["➡", "⬅", "⬆", "⬇", "⬈", "⬉", "⬊", "⬋"]
        },
        {
            title: "Setas Quadradas",
            arrows: ["⏴", "⏵", "⏶", "⏷"]
        },
        {
            title: "Setas Matemáticas",
            arrows: ["↦", "↤", "↥", "↧", "↬", "↭", "↮", "↯"]
        },
        {
            title: "Setas Unicode Extras",
            arrows: ["⇜", "⇝", "⇞", "⇟", "⇠", "⇢", "⇡", "⇣"]
        },
        {
            title: "Setas Decorativas",
            arrows: ["➔", "➘", "➙", "➚", "➛", "➜", "➝", "➞"]
        }
    ];

    return (
        <div className={styles.container}>

            {/* TÍTULO */}
            <h2 className={styles.title}>
                Biblioteca de Setas para Copiar
            </h2>

            {/* DESCRIÇÃO */}
            <p className={styles.description}>
                Copie facilmente símbolos de setas para usar em textos, sites, redes sociais ou projetos.
                Basta clicar na seta desejada e ela será copiada automaticamente.
            </p>

            {/* SEO BOX */}
            <section className={styles.infoBox}>
                <h3>Como usar as setas</h3>
                <p>
                    Esta ferramenta permite copiar rapidamente símbolos de setas Unicode com apenas um clique.
                    Ideal para desenvolvedores, designers, criadores de conteúdo e qualquer pessoa que precise
                    de símbolos visuais em textos.
                </p>

                <ul>
                    <li>✔ Clique em qualquer seta</li>
                    <li>✔ O símbolo será copiado automaticamente</li>
                    <li>✔ Cole onde quiser (Ctrl + V)</li>
                </ul>

                <p>
                    Você pode usar essas setas em HTML, CSS, redes sociais, documentos ou qualquer lugar que aceite texto.
                </p>
            </section>

            {/* GRID DE SETAS */}
            <div className={styles.arrowSections}>
                {arrowGroups.map((group, index) => (
                    <div key={index} className={styles.groupBox}>
                        <h3 className={styles.groupTitle}>{group.title}</h3>

                        <div className={styles.grid}>
                            {group.arrows.map((arrow, i) => (
                                <div
                                    key={i}
                                    className={styles.arrowItem}
                                    onClick={() => copySymbol(arrow)}
                                >
                                    {arrow}

                                    {copied === arrow && (
                                        <span className={styles.copied}>Copiado!</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* CONTEÚDO FINAL SEO */}
            <section className={styles.extraContent}>
                <h3>Para que servem esses símbolos?</h3>
                <p>
                    As setas são amplamente utilizadas para indicar direção, fluxo, navegação e destaque visual.
                    Elas são muito úteis em interfaces de usuário, textos explicativos, botões e até em biografias
                    de redes sociais.
                </p>

                <p>
                    Com esta biblioteca, você tem acesso rápido a uma grande variedade de estilos de setas,
                    desde simples até decorativas e técnicas.
                </p>
            </section>

            {/* AFILIADOS */}
            <div id="BoxAfiliados" className={styles.afiliados}></div>

        </div>
    );
};

export default ArrowForge;